import howToStepOne from '../../../../assets/images/homepageAssets/scrumBoard.svg';
import howToStepTwo from '../../../../assets/images/homepageAssets/onlineArticles.svg';
import howToStepThree from '../../../../assets/images/homepageAssets/onlineMedia.svg';
import howToStepFour from '../../../../assets/images/homepageAssets/socialNotifications.svg';

export default [
  {
    text: 'Discover Shootsta Premier',
    imagePath: howToStepOne,
    link: 'https://shootsta.com/shootsta-premier'
  },
  {
    text: 'Shootsta’s Latest News',
    imagePath: howToStepTwo,
    link: 'https://shootsta.com/resources/'
  },
  {
    text: 'Why Shootsta?',
    imagePath: howToStepThree,
    link: 'https://shootsta.com/'
  },
  {
    text: 'Take a tour of our suite of apps and services',
    imagePath: howToStepFour,
    link: 'https://shootsta.com/how-it-works'
  }
];
